import BetsCreatorScreen from '@/screens/BetsCreatorScreen';
import { AdminRouteGate } from '@/components/route/RouteGate';

export default function BetsCreatorRoute() {
  return (
    <AdminRouteGate requireBetsAdmin>
      <BetsCreatorScreen />
    </AdminRouteGate>
  );
}
